/**
 * Určuje variantu stylů TemplateLayout.
 */
export enum TemplateLayoutVariant {
    default = "default",
    gridParticipants = "grid-participants",
}
